(function ($, Drupal, drupalSettings, Promutuel) {
  var alertCookies = drupalSettings.alert_cookies;
  if (alertCookies && alertCookies.alert_cookies_content && alertCookies.alert_cookies_id) {
    if (!Promutuel.cookies.getSingleValue('alert_cookies_' + alertCookies.alert_cookies_id)) {
      Promutuel.cookies.set({
        name: 'alert_cookies_' + alertCookies.alert_cookies_id,
        value: 'true',
        path: '/',
        maxAge: 3600 * 24 *365 * 2 // Two years.
      });

      var modalSettings = {
        url: '/' + drupalSettings.path.pathPrefix + 'node/' + alertCookies.alert_cookies_content,
        dialogType: 'modal',
        dialog: {
          dialogClass: 'dialog-promutuel dialog-promutuel-cookie-alert',
          width: '95%',
          maxWidth: 800
        },
      };
      var promutuelModal = Drupal.ajax(modalSettings);
      promutuelModal.execute();
    }
  }
})(jQuery, Drupal, drupalSettings, Promutuel);
